<template>
    <div class="app-body"
         id="view">
        <div class="card p-4">
            <div class="box">
                <div class="box-header">
                    <div class="row pl-3 pr-3">
                        <div class="col-xl-3 mb-2">
                            <router-link :to="{ name: 'Dashboard' }">
                                <el-button size="medium">
                                    <i class="fa fa-caret-left mr-2"></i>
                                    Dashboard
                                </el-button>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-5">
                        <el-form class="form-aloware"
                                 ref="profileForm"
                                 :rules="rules"
                                 :model="user">
                            <template v-if="profile.is_reseller">
                                <el-form-item class="no-border"
                                              prop="company_name">
                                    <div class="form-label">
                                        <h5>Company name</h5>
                                    </div>
                                    <el-input placeholder="Company name"
                                              v-model="user.company_name"
                                              @input="preValidateForm('profileForm')">
                                    </el-input>
                                </el-form-item>
                                <el-form-item class="no-border"
                                              prop="first_name">
                                    <div class="form-label">
                                        <h5>First name</h5>
                                    </div>
                                    <el-input placeholder="First name"
                                              v-model="user.first_name"
                                              @input="preValidateForm('profileForm')">
                                    </el-input>
                                </el-form-item>
                                <el-form-item class="no-border"
                                              prop="last_name">
                                    <div class="form-label">
                                        <h5>Last name</h5>
                                    </div>
                                    <el-input placeholder="Last name"
                                              v-model="user.last_name"
                                              @input="preValidateForm('profileForm')">
                                    </el-input>
                                </el-form-item>
                            </template>
                            <template v-else>
                                <el-form-item class="no-border"
                                              prop="name">
                                    <div class="form-label">
                                        <h5>Name</h5>
                                    </div>
                                    <el-input placeholder="Name"
                                              v-model="user.name"
                                              @input="preValidateForm('profileForm')">
                                    </el-input>
                                </el-form-item>
                            </template>
                        </el-form>
                        <button class="btn btn-md _400 greenish pull-right"
                                @click="submitForm">
                            <span>Save</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import auth from '../auth'
import {
    validator_mixin,
    form_validation_mixin
} from "../../user/mixins"

export default {
    mixins: [
        validator_mixin,
        form_validation_mixin
    ],

    data() {
        return {
            profile: auth.user.profile,
            user: {
                company_name: null,
                name: null,
                first_name: null,
                last_name: null,
                email: null
            },
            rules: {}
        }
    },

    mounted() {
        this.presetAccountForm()
    },

    methods: {
        presetAccountForm() {
            if (this.profile.reseller) {
                this.user.company_name = this.profile.reseller.name
                this.rules.first_name = [
                    {
                        required: true,
                        message: 'Please enter your first name',
                        trigger: 'blur'
                    },
                    {
                        max: 190,
                        message: 'Name is too long'
                    }
                ]
                this.rules.last_name = [
                    {
                        required: true,
                        message: 'Please enter your last name',
                        trigger: 'blur'
                    },
                    {
                        max: 190,
                        message: 'Name is too long'
                    }
                ]
                this.rules.company_name = [
                    {
                        required: true,
                        message: 'Please enter the company name',
                        trigger: 'blur'
                    },
                    {
                        max: 190,
                        message: 'Name is too long'
                    }
                ]
            } else {
                this.rules.name = [
                    {
                        required: true,
                        message: 'Please enter your name',
                        trigger: 'blur'
                    },
                    {
                        max: 190,
                        message: 'Name is too long'
                    }
                ]
            }
            this.user.name = this.profile.name
            this.user.first_name = this.profile.first_name
            this.user.last_name = this.profile.last_name
            this.user.email = this.profile.email
        },

        submitForm() {
            if (this.validateForm('profileForm') == true) {
                this.updateAccount()
            } else {
                this.$notify({
                    offset: 95,
                    title: 'User',
                    dangerouslyUseHTMLString: true,
                    message: 'Please resolve validation issues.',
                    type: 'error',
                    showClose: true,
                })
                return false
            }
        },

        updateAccount: _.debounce(function () {
            let params = {
                company_name: this.user.company_name,
                name: this.user.name,
                first_name: this.user.first_name,
                last_name: this.user.last_name,
            };

            // Include email field if it is different from the initial value
            if (this.profile.email && (this.profile.email !== this.user.email)) {
                params.email = this.user.email
            }

            axios.patch('/api/admin/account', params)
                .then(res => {
                    if (res.status === 200) {
                        this.$notify({
                            offset: 95,
                            title: 'Profile',
                            message: 'Profile has been updated successfully.',
                            type: 'success',
                            showClose: true,
                        })
                    }

                    if (res.status !== 200) {
                        this.$notify({
                            offset: 95,
                            title: 'Profile',
                            message: res.data,
                            type: 'danger',
                            showClose: true,
                        })
                    }
                })
                .catch(err => {
                    this.$root.handleErrors(err.response)
                    this.presetAccountForm()
                })
        }, 500),
    },

    beforeRouteEnter(to, from, next) {
        auth.check()
            .then((res) => {
                next()
            })
            .catch((err) => {
                next({name: 'Login', query: {redirect: to.fullPath}})
            })
    }
}
</script>
